import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

const AUTH_MARKER = "dna_auth";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged in

  const checkAuth = async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem(AUTH_MARKER, "1");
      setUser(data);
    } catch {
      localStorage.removeItem(AUTH_MARKER);
      setUser(false);
    }
  };

  useEffect(() => {
    // Nur prüfen, wenn zuvor ein Login bestand – verhindert 401-Spam für normale Besucher
    if (localStorage.getItem(AUTH_MARKER) === "1") {
      checkAuth();
    } else {
      setUser(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(AUTH_MARKER, "1");
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem(AUTH_MARKER);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
